.badge {
  display: inline-flex;
  gap: var(--space-1);
  align-items: center;
  max-inline-size: 100%;
  block-size: calc(var(--space-5) + var(--space-1) / 2);
  padding-inline: var(--space-2);
  border: var(--border-width) solid transparent;
  border-radius: var(--radius-full);
  background: var(--color-surface-sunken);
  color: var(--color-text-muted);
  font-size: var(--text-xs);
  font-weight: var(--weight-medium);
  line-height: var(--leading-tight);
  white-space: nowrap;
  vertical-align: middle;
}

.badge > svg {
  inline-size: calc(var(--icon-sm) * 0.85);
  block-size: calc(var(--icon-sm) * 0.85);
}

.text {
  overflow: hidden;
  text-overflow: ellipsis;
}

.badge[data-tone="accent"] {
  background: var(--color-accent-subtle);
  color: var(--color-accent);
}

.badge[data-tone="success"] {
  background: var(--color-success-subtle);
  color: var(--color-success);
}

.badge[data-tone="warning"] {
  background: var(--color-warning-subtle);
  color: var(--color-warning);
}

.badge[data-tone="danger"] {
  background: var(--color-danger-subtle);
  color: var(--color-danger);
}

.badge[data-tone="info"] {
  background: var(--color-info-subtle);
  color: var(--color-info);
}

.badge[data-dashed] {
  border: var(--border-width) dashed var(--color-border-strong);
  background: transparent;
  color: var(--color-text-muted);
}
